import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class PermissionsLibService {

  contractPermissions: any = [];


  constructor() {
  }

  setContractPermissions(permissions: string[]) {
    this.contractPermissions = permissions;
  }

  getContractPermissions() {
    return this.contractPermissions;
  }

  hasPermission(permission: string) {
    return this.contractPermissions && this.contractPermissions.includes(permission);
  }

  extractMenuIds(menu: any[]): string[] {
    let ids: string[] = [];
    const extractIds = (items: any[]) => {
      for (const item of items) {
        if (item.id) {
          ids.push(item.id);
        }

        if (item.submenus && item.submenus.length > 0) {
          extractIds(item.submenus);
        }
      }
    };
    extractIds(menu);
    return ids;
  }



}
